import React, { useEffect, useState } from "react";
import ReactTyped from "react-typed";
import "react-typed/dist/animatedCursor.css";
import AnimatedLetters from "../Shared/AnimatedLetters/AnimatedLetters";
import LoadingSpinner from "../Shared/LoadingSpinner/LoadingSpinner";
import Sidebar from "../Shared/Sidebar/Sidebar";
import "./Home.modules.css";
import Lottie from "lottie-react";
import * as codingBoy from "../../assets/banner/coding_boy2_Green.json";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [letterClass] = useState("text-animate");
  const nameArray = ["I", "s", "h", "t", "i", "y", "a", "k"];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <section className="flex">
      <Sidebar></Sidebar>

      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <div className="lg:pl-[220px]">
          <div className="px-4 py-8 lg:py-0 lg:px-20 w-full">
            <div className="min-h-screen grid lg:grid-cols-2 content-center gap-y-4  ">
              <div className="flex lg:mt-16 animate__animated animate__fadeIn items-center order-last lg:order-first ">
                <div className="space-y-4 lg:space-y-6 w-full">
                  <div className="lg:space-y-8 text-dark-blue dark:text-white">
                    <h1 className="title-text text-3xl lg:text-[65px] font-bold text-center lg:text-left tracking-[.08em]">
                      Hi,
                    </h1>
                    <h1 className="title-text text-3xl lg:text-[65px] font-bold text-center lg:text-left tracking-[.08em]">
                      I'm{" "}
                      <AnimatedLetters
                        letterClass={letterClass}
                        strArray={nameArray}
                        idx={15}
                      ></AnimatedLetters>
                      ,
                    </h1>
                    <div className="title-text text-3xl lg:text-[45px] font-bold text-[#04BF00] text-center lg:text-left z-0 tracking-[.05em]">
                      <ReactTyped
                        loop
                        typeSpeed={90}
                        backSpeed={30}
                        startDelay={1000}
                        strings={[
                          "Web App Developer",
                          "MERN Stack Developer",
                          "Graphic Designer",
                        ]}
                        smartBackspace
                        shuffle={false}
                        backDelay={2000}
                        fadeOut={false}
                        fadeOutDelay={100}
                        loopCount={0}
                        showCursor={true}
                        cursorChar="|"
                      />
                    </div>
                  </div>
                  <div className="space-y-5">
                    <p className="text-dark-blue dark:text-[#dbdbdb] pt-2 text-center text-[14px] lg:text-[15px] lg:text-left lg:pr-16 para-text tracking-[.02em] lg:leading-[25px]">
                      I'm a passionate web developer and graphic designer. I
                      believe in success through hard work & dedication. I want
                      to join in a Professional life to gain exposure,
                      confidence & a sense of achievement.
                    </p>
                    <div className="text-center text-[14px] lg:text-left lg:pr-16 para-text tracking-[.02em] lg:leading-[25px]">
                      <div className="flex justify-center lg:justify-start items-center flex-wrap space-x-0 gap-2 dark:text-[#dbdbdb]">
                        <div className="px-4 py-1 shadow-sm rounded-sm bg-[#07101f90] dark:bg-[#07101f] cursor-pointer text-white dark:text-primary dark:hover:text-[#dbdbdb] hover:text-[#dbdbdb]">
                          Quick learner
                        </div>
                        <div className="px-4 py-1 shadow-sm rounded-sm bg-[#07101f90] dark:bg-[#07101f] cursor-pointer text-white dark:text-primary dark:hover:text-[#dbdbdb] hover:text-[#dbdbdb]">
                          Good Development Skills
                        </div>
                        <div className="px-4 py-1 shadow-sm rounded-sm bg-[#07101f90] dark:bg-[#07101f] cursor-pointer text-white dark:text-primary dark:hover:text-[#dbdbdb] hover:text-[#dbdbdb]">
                          Tech Enthusiast
                        </div>
                        <div className="px-4 py-1 shadow-sm rounded-sm bg-[#07101f90] dark:bg-[#07101f] cursor-pointer text-white dark:text-primary dark:hover:text-[#dbdbdb] hover:text-[#dbdbdb]">
                          Eco-Friendly Person
                        </div>
                        <div className="px-4 py-1 shadow-sm rounded-sm bg-[#07101f90] dark:bg-[#07101f] cursor-pointer text-white dark:text-primary dark:hover:text-[#dbdbdb] hover:text-[#dbdbdb]">
                          Punctuality and Integrity
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="text-center lg:text-left pt-2">
                    <a
                      className="resume-btn"
                      href="https://drive.google.com/file/d/1TeKGOGFB5AhqgPHZgh3y9HicK1yhF35-/view?usp=sharing"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span> My Resume
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex justify-center lg:justify-end animate__animated animate__fadeIn items-center">
                <div className="w-[250px] lg:w-[600px] mt-16">
                  {/* <img
                    className="shrink-0 mt-5 lg:absolute w-[880px] top-56 right-0"
                    src={bannerImg}
                    alt=""
                  /> */}
                  <Lottie animationData={codingBoy} loop={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Home;
